import React, { useState, useEffect} from 'react';
import "./index.scss";

import SearchInput from "./searchInput";
import QASearchInput from "../../../../../components/qASearchInput";
import KnowledgeTopic from "./knowledgeTopic"
import RecommendList from "./recommendList"
import homeAnimation from "../../../../../assets/img/V7/homeAnimation.gif"
const SearchBox = () => {
    const [searchNav, setSearchNav] = useState([
        {value:"1", label:"检索"},
        {value:"2", label:"AI问答"}
    ]);
    const [active, setActive] = useState('1');
    const switchMav = (index) => {
        setActive(index)
    }

    return (
        <div className="searchBox">
            <div className="searchInputBox">
                <div className="searchNav">
                    {searchNav.map((item, index) => (
                        <div className={`searchNavItem ${active === item.value ? 'active' : ''}`} key={item.value} onClick={()=>switchMav(item.value)}>{item.label}</div>
                    ))}
                    {active === '2' && <div className="homeAnimationBox">
                        <img src={homeAnimation}/>
                    </div>}
                    
                </div>

                {/* 检索 */}
                {active === '1' && (<SearchInput/>)}
                {/* 问答 */}
                {active === '2' && (<QASearchInput pageType={"home"}/>)}
            </div>

            {/* 知识专题 */}
            {active === '1' && (<KnowledgeTopic/>)}

            {/* 可能感兴趣 */}
            {active === '2' && (<RecommendList/>)}

        </div>
    );
}
export default SearchBox;
